import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useAuth } from '@/providers/AuthProvider';
import { useSelector } from 'react-redux';
import { selectCachedUserDataById } from '@/store/queries';
import { useLazyGetUsersQuery } from '@/store/api/userApi';
import { useTranslation } from 'react-i18next';
import { BaseAvatar, BaseTooltip } from '@/components';
import { useToast } from '@/hooks/shared/use-toast';

export const User = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const { t } = useTranslation();
  const userData = useSelector((state) => selectCachedUserDataById(state, user!.uid));
  const fullName = userData ? `${userData.first_name} ${userData.last_name}` : '';
  const initials = userData ? `${userData.first_name[0]}${userData.last_name[0]}` : '';
  const [fetchUsers] = useLazyGetUsersQuery();

  useEffect(() => {
    if (user) {
      fetchUsers({ uids: user.uid }, true)
        .unwrap()
        .catch((error) => {
          toast({
            variant: 'destructive',
            title: t('general.errors.title'),
            description: t('general.errors.communication'),
          });

          Sentry.captureException(
            error?.data?.message || error?.error || error?.message || error?.originalError || error
          );
        });
    }
  }, [user]);

  return (
    <div>
      <BaseTooltip
        content={fullName}
        tooltipProps={{
          delayDuration: 100,
          disableHoverableContent: true,
        }}
        contentProps={{
          sideOffset: 10,
        }}
      >
        <BaseAvatar
          initials={initials}
          imageSrc={userData?.photo ? `data:image/png;base64,${userData.photo}` : undefined}
          classNames={{
            avatar: 'w-[50px] h-[50px] border-2 border-[#6667DD] p-[2px]',
            image: 'rounded-full',
            fallback:
              'w-full h-full flex justify-center items-center text-white text-[17px] bg-[var(--avatar-bg)] font-semibold',
          }}
        />
      </BaseTooltip>
    </div>
  );
};
